import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

import { AvatarEvents } from './avatarAnalytics.types'

class AvatarTutorialAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.AVATAR_TUTORIAL)
  }

  public logAvatarTour({ step, out = 0, finished = 0 }: { step: number; out?: number; finished?: number }): void {
    this.logEvent({
      event: AvatarEvents.CREATE_AVATAR_TOUR,
      step,
      out,
      finished,
    })
  }
}

export default new AvatarTutorialAnalytics()
